import { buildStatusOptions } from '@/shared/constants/statusOptions';
import type { GridColumnVisibilityModel } from '@/ui/primitives';
import type { BuildStatus } from '@flowqa/shared';

export type PipelineTableStatus = BuildStatus | 'none';
export type PipelineSortDirection = 'asc' | 'desc';
export type PipelineSortKey =
  | 'name'
  | 'latestBuildTimestamp'
  | 'metrics.passRate'
  | 'metrics.passRateDelta'
  | 'metrics.frequencyPerDay'
  | 'metrics.frequencyPerDayDelta'
  | 'metrics.averageDurationMs'
  | 'metrics.averageDurationMsDelta';

export const pipelineDefaultSortKey: PipelineSortKey = 'latestBuildTimestamp';
export const pipelineDefaultSortDirection: PipelineSortDirection = 'desc';

export const pipelineSortOptions: Array<{ key: PipelineSortKey; label: string }> = [
  { key: 'name', label: 'Pipeline Name' },
  { key: 'latestBuildTimestamp', label: 'Latest' },
  { key: 'metrics.passRate', label: 'Pass Rate' },
  { key: 'metrics.passRateDelta', label: 'Pass Rate Delta' },
  { key: 'metrics.frequencyPerDay', label: 'Frequency' },
  { key: 'metrics.frequencyPerDayDelta', label: 'Frequency Delta' },
  { key: 'metrics.averageDurationMs', label: 'Avg. Duration' },
  { key: 'metrics.averageDurationMsDelta', label: 'Avg. Duration Delta' },
];

export const pipelineSortFieldMap: Record<PipelineSortKey, string> = {
  name: 'name',
  latestBuildTimestamp: 'latestBuildTimestamp',
  'metrics.passRate': 'executionPassRate',
  'metrics.passRateDelta': 'executionPassRateDelta',
  'metrics.frequencyPerDay': 'executionFrequencyPerDay',
  'metrics.frequencyPerDayDelta': 'executionFrequencyPerDayDelta',
  'metrics.averageDurationMs': 'executionAverageDurationMs',
  'metrics.averageDurationMsDelta': 'executionAverageDurationMsDelta',
};

export const pipelineColumnOptions: Array<{ field: string; label: string; mandatory?: boolean }> = [
  { field: 'name', label: 'Pipeline', mandatory: true },
  { field: 'latestBuildStatus', label: 'Latest Status' },
  { field: 'buildStatusCounts', label: 'Builds' },
  { field: 'metricsSummary', label: 'Metrics' },
  { field: 'actions', label: 'Actions' },
];

export const pipelineStatusOptions: Array<{ value: PipelineTableStatus; label: string }> = [
  ...buildStatusOptions,
  { value: 'none', label: 'No Builds' },
];

export const pipelineDefaultColumnVisibilityModel: GridColumnVisibilityModel = {
  name: true,
  latestBuildStatus: true,
  buildStatusCounts: true,
  metricsSummary: true,
  actions: true,
};
